module.exports = __webpack_public_path__ + "static/media/boy-9.7a86b6b2.svg";